export const geocoderService: { current: google.maps.Geocoder | null } = { current: null }

export const loadScript = (src: string, position: HTMLElement | null, id: string) => {
  if (!position) {
    return
  }

  const script = document.createElement('script')
  script.setAttribute('async', '')
  script.setAttribute('id', id)
  script.src = src
  position.appendChild(script)
}

export const fetchAddressInfo = async (placeId: string) => {
  if (!geocoderService.current) {
    return null
  }

  const details = await geocoderService.current?.geocode({ placeId })

  if (!details || details?.results.length === 0) {
    return null
  }

  const result = details.results[0]
  const addressComponents = result.address_components

  const googleAddress: IGoogleAddress = {
    city: addressComponents.find((s) => s.types.includes('locality'))?.long_name ?? '',
    route: addressComponents.find((s) => s.types.includes('route'))?.long_name ?? '',
    street_number: addressComponents.find((s) => s.types.includes('street_number'))?.long_name ?? '',
    subpremise: addressComponents.find((s) => s.types.includes('subpremise'))?.long_name ?? '',
    state: addressComponents.find((s) => s.types.includes('administrative_area_level_1'))?.short_name ?? '',
    postalCode: addressComponents.find((s) => s.types.includes('postal_code'))?.short_name ?? '',
    country: addressComponents.find((s) => s.types.includes('country'))?.short_name ?? '',
  }

  const addressForm: AddressFormValues = {
    address: [googleAddress.street_number, googleAddress.route].filter((x) => x).join(' '),
    address2: googleAddress.subpremise ?? '',
    locality: googleAddress.city ?? '',
    region: googleAddress.state ?? '',
    country: googleAddress.country ?? '',
    code: googleAddress.postalCode ?? '',
  }

  return addressForm
}
